import Link from "next/link";

import { Col } from "react-bootstrap";

import { ItemProps } from "./navigation.config";

type MegaMenuItemProps = {
  subItem: ItemProps;
  active: boolean;
  handleClose: () => void;
};

export default function MegaMenuItem({ subItem, active, handleClose }: MegaMenuItemProps) {
  return (
    <Col lg="6">
      <Link href={subItem.url} className={`mega-menu-link${active ? " active" : ""}`} onClick={handleClose}>
        {subItem.label}
      </Link>
      <p className="mega-menu-description">{subItem.description}</p>
    </Col>
  );
}
